module.exports = __webpack_public_path__ + "static/media/ad.f38ad647.png";